import { connect } from 'react-redux';
import AdminMenuView from './index'
import {loadPages} from '../../../actions/Pages'
import {login, logout} from '../../../actions/Session'
const mapStateToProps = (state, props) => {  
    return {
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	logout: (data) => {
	    return dispatch(logout(data))
	}
    }
}

const AdminMenuContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminMenuView);




export default AdminMenuContainer;



// WEBPACK FOOTER //
// ./src/components/Layout/AdminMenu/Container.js